import { useQuery } from "@tanstack/react-query";

import { apiFetch } from "@/lib/api";
import type { Enums } from "@/lib/api-types";

/**
 * `GET /meta/enums` (AD-2), cached once via TanStack Query so every screen
 * that needs a role or status list — a filter dropdown, a badge — shares
 * one answer and one network request, the same pattern `useCurrentActor`
 * (`lib/current-actor.ts`) already established for the current-actor route.
 */
export const ENUMS_QUERY_KEY = ["meta", "enums"] as const;

export function useEnums() {
  return useQuery({
    queryKey: ENUMS_QUERY_KEY,
    queryFn: () => apiFetch<Enums>("/meta/enums"),
  });
}
